<template>
  <div
    class="tw:relative tw:w-full tw:transition-all tw:duration-300"
    :style="dynamicContainerStyles"
  >
    <Transition
      appear
      name="aibox"
    >
      <div
        v-if="isContainerOpen"
        class="ai-background-gradient tw:relative tw:mx-auto tw:mb-2 tw:flex tw:w-full tw:flex-col tw:overflow-hidden tw:rounded-3xl tw:border tw:border-solid tw:border-white tw:px-2 tw:pb-3 tw:shadow-[0px_4px_4px_0px_rgba(0,0,0,0.10)] tw:transition-all tw:duration-300"
        :class="{ 'ai-animated-gradient': loading }"
        :style="dynamicAIBoxStyles"
      >
        <div class="tw:z-10">
          <slot name="result" />
        </div>
      </div>
    </Transition>

    <div class="tw:absolute tw:top-0 tw:w-full">
      <slot name="input" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface SuggestedKeywordsAIContainerProps {
  isContainerOpen?: boolean;
  loading?: boolean;
  isAdvanceKeyword?: boolean;
  filterOpen?: boolean;
  inputHeight?: number;
}

const props = defineProps<SuggestedKeywordsAIContainerProps>();

const dynamicAIBoxStyles = computed(() => {
  const height = `${123 + (props.inputHeight ?? 0)}px`;
  const paddingTop = `${18 + (props.inputHeight ?? 0)}px`;

  return {
    height,
    paddingTop,
  };
});

const dynamicContainerStyles = computed(() => {
  let dynamicHeight = props.inputHeight ?? 0;

  if (!props.isAdvanceKeyword) {
    dynamicHeight += 10;
  }

  if (props.isContainerOpen) {
    dynamicHeight += 130;
  }

  const height = `${dynamicHeight}px`;

  return {
    height,
  };
});
</script>

<style lang="scss" scoped>
@import "shared/css/components/ai.scss";

@keyframes box {
  0% {
    transform: scaleY(0);
    opacity: 0;
  }

  80% {
    transform: scaleY(1.1);
    opacity: 1;
  }

  100% {
    transform: scaleY(1);
    opacity: 1;
  }
}

.aibox-appear-from,
.aibox-enter-from {
  transform: scaleY(0);
  opacity: 0;
}

.aibox-appear-to,
.aibox-enter-to {
  transform: scaleY(1);
  opacity: 1;
}

.aibox-appear-active,
.aibox-enter-active {
  animation: box 0.6s ease-out forwards;
  animation-delay: 500ms;
  transform-origin: top;
  opacity: 0;
}

.aibox-leave-from {
  transform: scaleY(1);
  opacity: 1;
}

.aibox-leave-to {
  transform: scaleY(0);
  opacity: 0;
}

.aibox-leave-active {
  transition: ease-in-out;
  transition-duration: 0.3s;
  transform-origin: top;
}
</style>
